<!--Copyright (c) Method Development, LLC.  All rights reserved.-->

<Notify />

<!--<pre class="debug"><code>{JSON.stringify(xsrfToken)}</code></pre>-->
<!--<pre class="debug"><code>{JSON.stringify(model)}</code></pre>-->
<!--<pre class="debug"><code>{JSON.stringify(helper)}</code></pre>-->

<div class="{ helper.spinnerInit === true ? 'pulse-line' : 'pulse-none' }"></div>
{#if helper.spinnerInit === true }
<div class="pulse-overlay"></div>
{/if}

<div style="{ helper.spinnerInit === true ? 'visibility:hidden;' : null }">

    <div class="container">

        <div class="card">
            <div class="card-header">
                <h1 class="fs-5">NE Eagle Scout: Signup</h1>
                <div class="mt-5">
                    <div class="step-indicator">
                        <div class="step active">
                            <div class="step-connector"></div>
                            <div class="step-number">1</div>
                            <div class="step-title">Signup</div>
                        </div>
                        <div class="step">
                            <div class="step-connector"></div>
                            <div class="step-number">2</div>
                            <div class="step-title">Confirm</div>
                        </div>
                        <div class="step">
                            <div class="step-connector"></div>
                            <div class="step-number">3</div>
                            <div class="step-title">Application</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="row justify-content-center">
                    <div class="col col-md-6">

                        <p class="fs-3">Items you will need when applying:</p>

                        <ul>
                            <li>An accessible non-school email address</li>
                            <li>Troop #, council name and year you earned Eagle Scout rank</li>
                            <li>Home address and county</li>
                            <li>High school address, graduation month and year</li>
                            <li>Nebraska college you plan to attend with anticipated start month and year</li>
                        </ul>

                        <div class="row">
                            <div class="col mb-3">
                                <ul class="validation-summary" aria-live="assertive"></ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col mb-3">
                                <label for="firstName">Legal First Name *</label>
                                <input id="firstName" name="firstName" class="form-control" type="text" bind:value="{model.firstName}" aria-required="true" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col mb-3">
                                <label for="lastName">Legal Last Name *</label>
                                <input id="lastName" name="lastName" class="form-control" type="text" bind:value="{model.lastName}" aria-required="true" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col mb-3">
                                <label for="email">Email *</label>
                                <input id="email" name="email" class="form-control" type="text" bind:value="{model.email}" aria-required="true" />
                                <sub class="text-muted">You will be sent an email notification with code to confirm your email address.</sub>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col col-md-6 text-center">
                        <button class="btn btn-primary w-50" type="button" on:click="{ post }" disabled="{ helper.spinner === true }">Signup <i class="{ helper.spinner === true ? 'fa-solid fa-spinner fa-spin' : 'hide' }"></i></button>
                    </div>
                </div>

            </div>
        </div>

    </div>

</div>

<script>
    import { url } from "../lib/url.js";
    import { helperFetch } from "../lib/common.js";
    import { notify } from "../lib/store.js";
    import Notify from "../component/Notify.svelte";

    //helperFetch: validationVisibility
    addEventListener("validationVisibility", (e) => {
        helperFetch.validationSummaryVisible = e.detail.validationSummaryVisible;
    });

    export let xsrfToken = null;

    const constant = {
    }

    let model = {
    };

    let helper = {
        spinnerInit: false,
        spinner: false
    };

    const post = async () => {

        //data
        let body = Object.assign({}, model);

        //ui
        helper.spinner = true;

        await fetch(url.api.eagleScoutAppSignup, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: xsrfToken,
            },
            body: JSON.stringify(body),
        })
            .then(helperFetch.fetchHandler)
            .then(response => {

                //ui
                helper.spinner = false;
            })
            .catch(error => {

                //handle
                helperFetch.errorHandler(error);

                //ui
                helper.spinner = false;
            });

    };

</script>

